import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { ClearToApply } from '../../model/ngrx/clear-to-apply.model';

export const ADD_CLEAR_TO_APPLY = '[CLEARTOAPPLY] Add';
export const REMOVE_CLEAR_TO_APPLY = '[CLEARTOAPPLY] Remove';

// AddPersonalDetails
export class AddClearToApply implements Action {
    readonly type = ADD_CLEAR_TO_APPLY;

    constructor(public payload: ClearToApply) { }
}
// RemovePersonalDetails
export class RemoveClearToApply implements Action {
    readonly type = REMOVE_CLEAR_TO_APPLY;

    constructor(public payload: number) { }
}

export type Actions = AddClearToApply | RemoveClearToApply;
